import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    Typography,
    Alert,
    Checkbox,
    FormControlLabel,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    ToggleButton,
    ToggleButtonGroup,
} from '@mui/material';
import RequestService from '../../services/RequestService';

const NewGroupDialog = ({
    open,
    onClose,
    group,
    onSuccess,
    user,
    isEdit = false,
}) => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        gameId: '',
        daysOfWeek: [],
        startTime: '',
        endTime: '',
    });

    const [games, setGames] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchGames = async () => {
            try {
                const data = await RequestService.getGames(user.company.id);
                setGames(Array.isArray(data) ? data : []);
            } catch (err) {
                setGames([]);
                setError('Erro ao carregar jogos.');
            }
        };

        fetchGames();
    }, [user.company.id]);

    useEffect(() => {
        if (group && isEdit) {
            setFormData({
                name: group.name || '',
                description: group.description || '',
                gameId: group.game?.id || null,
            });
        }
    }, [group, isEdit]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleToggleChange = (name) => (event, value) => {
        if (value !== null) {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async () => {
        if (!formData.gameId) {
            setError('Selecione um jogo antes de continuar.');
            return;
        }

        try {
            const payload = {
                ...formData,
                companyId: user.company.id,
            };

            if (isEdit) {
                await RequestService.updateGroup(group.id, payload);
            } else {
                await RequestService.createGroup(payload);
            }

            onSuccess();
            onClose();
        } catch (err) {
            setError('Erro ao salvar o grupo. Verifique os dados.');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{isEdit ? 'Editar Grupo' : 'Novo Grupo'}</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                        label="Nome do Grupo"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        fullWidth
                    />
                    <TextField
                        label="Descrição"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        fullWidth
                        multiline
                        rows={3}
                    />
                    <FormControl fullWidth>
                        <InputLabel id="game-select-label">Jogo</InputLabel>
                        <Select
                            labelId="game-select-label"
                            name="gameId"
                            value={formData.gameId}
                            onChange={handleChange}
                        >
                            {(Array.isArray(games) ? games : []).map((game) => (
                                <MenuItem key={game.id} value={game.id}>
                                    {game.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Typography variant="body1">Dias da Semana</Typography>
                    <ToggleButtonGroup
                        value={formData.daysOfWeek}
                        onChange={handleToggleChange('daysOfWeek')}
                        fullWidth
                        multiple
                    >
                        <ToggleButton value={1}>Seg</ToggleButton>
                        <ToggleButton value={2}>Ter</ToggleButton>
                        <ToggleButton value={3}>Qua</ToggleButton>
                        <ToggleButton value={4}>Qui</ToggleButton>
                        <ToggleButton value={5}>Sex</ToggleButton>
                        <ToggleButton value={6}>Sáb</ToggleButton>
                        <ToggleButton value={7}>Dom</ToggleButton>
                    </ToggleButtonGroup>
                    <TextField
                        label="Hora de Início"
                        name="startTime"
                        type="time"
                        value={formData.startTime}
                        onChange={handleChange}
                        fullWidth
                    />
                    <TextField
                        label="Hora de Fim"
                        name="endTime"
                        type="time"
                        value={formData.endTime}
                        onChange={handleChange}
                        fullWidth
                    />
                    {error && <Alert severity="error">{error}</Alert>}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Fechar
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                >
                    {isEdit ? 'Salvar Alterações' : 'Criar Grupo'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NewGroupDialog;
